export class RadioHarnessController {
  public source: any[];
  public multiLineSource: any[];
  public formattedSource: any[];
  public value: string;
  public value1: string;
  public value2: string;

  constructor() {
    this.source = ["text1", "text2", { text: "text3" }];
    this.multiLineSource = [
      ["700 - Chacara Santo", "Antonio", "Sao Paolo", "98055-5300", "BR"],
      ["924 S 32ND ST", "Antonio", "Renton, WA", "98055-5300", "US"],
      ["123 Fake St.", "Springfield", "98122"]
    ];
    this.formattedSource = [
      "<span aria-label='Chacara Santo' data-bi-name='Sao Paolo'>700 - Chacara Santo</br><span aria-label='Antonio'>Antonio<span></br>Sao Paolo</br>98055-5300</br>BR</span>",
      "924 S 32ND ST</br>Antonio</br>Renton, WA</br>98055-5300</br>US"
    ];
  }
}
